module.exports = __webpack_public_path__ + "img/zwaardboten--dark.6cb90621.svg";